/** Map lasso + colour-ramp helpers for Well map v2 (pure; unit-tested under node). */

/** Ray-casting point-in-polygon; poly = [[x,y], ...] in any planar space. */
export function pointInPolygon([x, y], poly) {
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i, i += 1) {
    const [xi, yi] = poly[i];
    const [xj, yj] = poly[j];
    if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi || 1e-12) + xi) inside = !inside;
  }
  return inside;
}

/** Wells (with projected .px/.py or lat/lng) inside the lasso polygon. */
export function lassoSelect(wells, poly, project = (w) => [w.lng, w.lat]) {
  if (!Array.isArray(poly) || poly.length < 3) return [];
  return wells.filter((w) => {
    const pt = project(w);
    return pt && Number.isFinite(pt[0]) && Number.isFinite(pt[1]) && pointInPolygon(pt, poly);
  });
}

export function colorMetrics(product = 'gas') {
  const unit = product === 'oil' ? 'Mbbl' : 'MMcf';
  return {
    eur: { label: `EUR (${unit})`, get: (w) => (w.fit?.eur != null ? w.fit.eur / 1000 : null) },
    remaining: { label: `Remaining (${unit})`, get: (w) => (w.fit?.remaining != null ? w.fit.remaining / 1000 : null) },
    decline: { label: 'Current decline (%/yr)', get: (w) => w.fit?.declineNowEffPct ?? null },
    quality: { label: 'Fit quality', get: (w) => ({ A: 3, B: 2, C: 1 })[w.fit?.quality] ?? null },
    review: { label: 'Review status', get: (w) => w.reviewStatus ?? null },
    tracking: { label: 'Production tracking (actual ÷ UW)', get: (w) => w.backtest?.trackingRatio ?? null },
  };
}

export const COLOR_METRICS = colorMetrics('gas');

const RAMP = ['#dcfce7', '#86efac', '#14b8a6', '#163a4f', '#0c1f2e'];
export const REVIEW_COLORS = { approved: '#059669', reviewed: '#2563eb', rejected: '#dc2626', draft: '#94a3b8' };

/** Quantile colour ramp; null → muted grey. Returns {color(v), breaks}. */
export function quantileRamp(values, colors = RAMP) {
  const xs = values.filter((v) => v != null && Number.isFinite(v)).sort((a, b) => a - b);
  const breaks = colors.slice(1).map((_, i) => xs[Math.floor(((i + 1) / colors.length) * (xs.length - 1))]);
  return {
    breaks,
    color(v) {
      if (v == null || !Number.isFinite(v)) return '#cbd5e1';
      let k = 0;
      while (k < breaks.length && v > breaks[k]) k += 1;
      return colors[k];
    },
  };
}
